// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".changePasswordSection{\r\n    height: 100% !important;\r\n  }\r\n  ", "",{"version":3,"sources":["webpack://./src/components/changePassword/change-password.css"],"names":[],"mappings":"AAAA;IACI,uBAAuB;EACzB","sourcesContent":[".changePasswordSection{\r\n    height: 100% !important;\r\n  }\r\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
